// extracted by mini-css-extract-plugin
export default {"startBodyWrapper":"Body_startBodyWrapper__uDSRn"};